import { getBreakpointsDetails } from './utils/getBreakpointsDetails';

export const defaultBreakpoints = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};

export const defaultBreakpointsDetails =
  getBreakpointsDetails(defaultBreakpoints);
